module.exports = __webpack_public_path__ + "static/media/ncbi.ac389c48.jpg";